import { useEffect, useRef } from 'react';
import { useBusinessChannelEventBinder } from '~/pusher/useBusinessChannelEventBinder';
import { useCompletionToast } from '../TasksDrawerRoot/hooks/useCompletionToast';
import { applyJobPatch, JOB_UPDATE_EVENT_NAME } from '../TasksDrawerRoot/utils/jobUpdatePayload';
import { useTasksDrawerStoreApi } from '../tasksDrawerStore';
import { useTasksJobs } from './useTasksJobs';
function awaitedCompletion(awaited, payload) {
    if (payload.status !== 'ready' && payload.status !== 'failed') return null;
    return {
        jobId: awaited.jobId,
        kind: awaited.kind,
        relationshipId: awaited.relationshipId,
        agreementName: awaited.agreementName,
        nextStatus: payload.status,
        downloadUrl: payload.status === 'ready' ? payload.downloadUrl : undefined,
        overrides: awaited.overrides
    };
}
export function useJobsListener() {
    const { optimisticUpdate, refresh } = useTasksJobs({
        refreshOnHookMount: true
    });
    const reportCompletion = useCompletionToast();
    useJobsChannelBinder({
        optimisticUpdate,
        refresh,
        reportCompletion
    });
}
function useJobsChannelBinder(param) {
    let { optimisticUpdate, refresh, reportCompletion } = param;
    const { startListening, unbind } = useBusinessChannelEventBinder(JOB_UPDATE_EVENT_NAME, 'scout');
    const drawerStore = useTasksDrawerStoreApi();
    const unbindRef = useRef(unbind);
    unbindRef.current = unbind;
    useEffect(()=>{
        startListening((payload)=>{
            let matched = false;
            optimisticUpdate((tasks)=>{
                matched = tasks.some((t)=>t.jobId === payload.jobId);
                if (!matched) return tasks;
                return tasks.map((t)=>t.jobId === payload.jobId ? applyJobPatch(t, payload) : t);
            });
            if (!matched) void refresh();
            const { awaitedJobs, dropAwaitedJob } = drawerStore.getState();
            const awaited = awaitedJobs.get(payload.jobId);
            if (awaited == null) return;
            const transition = awaitedCompletion(awaited, payload);
            if (transition == null) return;
            dropAwaitedJob(payload.jobId);
            reportCompletion(transition);
        });
        return ()=>unbindRef.current();
    }, [
        optimisticUpdate,
        refresh,
        drawerStore,
        reportCompletion
    ]);
}
